import React from 'react';
import { connect } from 'react-redux';
import { CreatorProfileContainerStyled } from './styled';
import { adminService } from 'apiService';
import { toast } from 'react-toastify';
import { setReduxUserAuth } from 'actions';
import { CreatorProfileFormSec1 } from 'forms/AdminFormSystem';

class CreatorProfileContainer extends React.Component {
  state = {};

  componentDidMount() {
    const { creatorID } = this.props;
    if (creatorID) {
      this.fetchData();
    }
  }

  fetchData = async () => {
    const { creatorID } = this.props;
    let res = await adminService.GET_CREATOR_DETAIL(creatorID);
    if (res && res.success) {
      this.setState({
        data: res.data,
        initialValues: {
          ...res.data,
          user_id: res.data.user ? String(res.data.user.name) : undefined,
        },
      });
    }
  };

  handdleSave = async () => {
    const { data } = this.state;
    const {
      reduxForm: { values, syncErrors },
      creatorID,
      callback,
    } = this.props;
    let params = {
      ...values,
      is_highlight: values.is_highlight ? values.is_highlight : 0,
      is_upcoming: values.is_upcoming ? values.is_upcoming : 0,
      is_active: values.is_active ? values.is_active : 0,
      is_newarrival: values.is_newarrival ? values.is_newarrival : 0,
      is_explore: values.is_explore ? values.is_explore : 0,
    }; 
    if (values.user_id) {
      params.user_id =
        typeof values.user_id === 'string' ? data.user.id : values.user_id.id;
    }
    if (typeof syncErrors === 'object') {
      toast.error('กรุณากรอกข้อมูลให้ครบถ้วน', {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      if (!creatorID) {
        let res = await adminService.POST_CREATOR_ADD(params);
        if (res && res.success) {
          toast.success('บันทึกสำเร็จ');
          callback && callback(res.data.id);
        } else {
          toast.error('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
        }
      } else {
        let res = await adminService.PATCH_CREATOR_UPDATE(creatorID, params);
        if (res && res.success) {
          toast.success('บันทึกสำเร็จ');
        } else {
          toast.error('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
        }
      }
    }
  };

  render() {
    const { initialValues } = this.state;
    return (
      <CreatorProfileContainerStyled>
        <CreatorProfileFormSec1
          initialValues={initialValues}
          handdleSave={this.handdleSave}
        />
      </CreatorProfileContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authRedux: state.auth,
  reduxForm: state.form.CreatorProfileFormSec1,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxUserAuth: (data) => dispatch(setReduxUserAuth(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatorProfileContainer);
